import { Button } from '../../ui/Button';
import './styles.css';

export function CallToAction() {
  return (
    <section id="community" className="cta">
      <div className="container">
        <div className="ctaCard">
          <h2>Build Your International Academic Network</h2>
          <p>Start collaborating with students across Europe today. No credit card required.</p>
          <div className="ctaActions">
            <Button className="btnOnDark" soon variant="primary">
              Get Started Free
            </Button>
            <Button className="btnOnDark" href="#projects" variant="secondary">
              Explore Projects
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}

